import { createAsyncThunk } from '@reduxjs/toolkit';
import { REDUCER_NAME } from './initialState';
import { userWhiteListApi } from '../../../api/userWhiteListApi';

export const GetUserWhiteList = createAsyncThunk(`${REDUCER_NAME}/GetUserWhiteList`, async (_, thunkAPI) => {
  const res = await userWhiteListApi.get();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const AddUserToWhiteList = createAsyncThunk<any, string, { rejectValue: { status: string; message: string } }>(
  `${REDUCER_NAME}/AddUserToWhiteList`,
  async (userId, thunkAPI) => {
    const res = await userWhiteListApi.addUserToWhiteList(userId);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const RemoveUserFromWhiteList = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/RemoveUserFromWhiteList`,
  async (userId, thunkAPI) => {
    const res = await userWhiteListApi.removeUserFromWhiteList(userId);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
